import { useMutation } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";
import type {
    MaterialLineItemsResponse,
    LaborLineItemsResponse,
} from "../../components/EstimateContract/types";

type LineItemsParams = {
    ProjectId: string;
};

export default function useRoofingEstimator() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useIdentifyProducts() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate
                    .post(`/v1/roofing-estimator/identify-products`, parameters)
                    .then(parseSuccessResponseData),
        });
    }

    function useIdentifyLabor() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate
                    .post(`/v1/roofing-estimator/identify-labor`, parameters)
                    .then(parseSuccessResponseData),
        });
    }

    function useMaterialLineItems() {
        return useMutation({
            mutationFn: (parameters: LineItemsParams) =>
                axiosPrivate
                    .post(`/v1/roofing-estimator/material-line-items`, parameters)
                    .then(
                        (response) =>
                            parseSuccessResponseData(
                                response,
                            ) as MaterialLineItemsResponse,
                    ),
        });
    }

    function useLaborLineItems() {
        return useMutation({
            mutationFn: (parameters: LineItemsParams) =>
                axiosPrivate
                    .post(`/v1/roofing-estimator/labor-line-items`, parameters)
                    .then(
                        (response) =>
                            parseSuccessResponseData(
                                response,
                            ) as LaborLineItemsResponse,
                    ),
        });
    }

    return {
        useIdentifyProducts,
        useIdentifyLabor,
        useMaterialLineItems,
        useLaborLineItems,
    };
}
